export default function Hero() {
  const scrollToGraphs = () => {
    const graphsSection = document.getElementById('sp-graphs');
    if (graphsSection) {
      graphsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const whatsappMessage = encodeURIComponent('Hola, me gustaría agendar una asesoría personalizada para invertir en los mercados financieros. Vi tu página de inversiones en índices.');
  const whatsappLink = `https://wa.me/593981562448?text=${whatsappMessage}`;

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Fondo con degradado */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-[#0A1A35] to-black">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#D4AF37]/10 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Contenido izquierdo */}
          <div className="space-y-8 fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Multiplica tu capital con estrategias basadas en los{' '}
              <span className="text-[#D4AF37]">índices más sólidos</span> del mercado global.
            </h1>

            <p className="text-xl text-[#C5C7D0] leading-relaxed">
              Inversiones inteligentes para Ecuador y LATAM, con estructuras claras, seguras y accesibles.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={scrollToGraphs}
                className="px-8 py-4 bg-[#D4AF37] text-black font-semibold rounded-lg hover:bg-[#A87E10] transition-all duration-300 shadow-lg hover:shadow-[#D4AF37]/50 whitespace-nowrap cursor-pointer"
              >
                Ver rendimiento histórico del S&amp;P500
              </button>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 border-2 border-[#D4AF37] text-[#D4AF37] font-semibold rounded-lg hover:bg-[#D4AF37] hover:text-black transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
              >
                Hablar por WhatsApp
              </a>
            </div>
          </div>

          {/* Espacio para foto de Mario Moya */}
          <div className="relative fade-in-delay">
            <div className="relative aspect-square max-w-md mx-auto">
              {/* Efecto de resplandor dorado */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/30 to-[#A87E10]/20 rounded-full blur-3xl"></div>
              
              {/* Contenedor de imagen */}
              <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-[#D4AF37]/50 shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/1705c9fe72ac2ac39b2fe4bda7c8679f/296b1f0a84b3fdb7b631dcf889ad7a10.jpeg"
                  alt="Mario Moya - Asesor de Inversiones"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Detalles decorativos */}
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#D4AF37]/20 rounded-full blur-2xl"></div>
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#0A1A35]/50 rounded-full blur-xl"></div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .fade-in {
          animation: fadeIn 1s ease-in;
        }
        .fade-in-delay {
          animation: fadeIn 1s ease-in 0.3s both;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
